import { ChangeDetectorRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';

import { PuntoGrupo } from 'src/app/models/punto-grupo.model';
import { Gtp } from 'src/app/shared/gtp';
import { PuntosService } from 'src/app/shared/services/puntos-service/puntos.service';
import { MapToolsService } from '../../../services/map-tools.service';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

declare var google: any;

@Component({
  selector: 'app-tools-puntoscliente',
  templateUrl: './tools-puntoscliente.component.html',
  styleUrls: ['./tools-puntoscliente.component.scss']
})
export class ToolsPuntosClienteComponent implements OnInit, AfterViewInit {

  //@Input() moviles: any;
  @Output() eventClose = new EventEmitter<any>();
  //@Output() irAMovil = new EventEmitter<any>();
  @Output() irAPunto = new EventEmitter<any>();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('puntoslista') select: MatSelect;

  public pageEvent: PageEvent;

  //public listaMoviles = [];
  //public listaMovilesFiltered = [];
  public mostrarTodos: boolean = true;
  event: Event;

  public grupos: any = [];
  public gruposFiltered: any = [];

  //public listaPuntos: object[] = [];
  //public listaPuntosFiltered: object[] = [];
  public listaPuntos = [];
  public listaPuntosFiltered = [];

  public pageIndex: number = 0;
  public pageSize: number = 10;
  public loadingXls: boolean = false;
  public dataSource: MatTableDataSource<any>;
  public tableCount;
  public displayedColumns: string[] = [
    'punto',
  ];

  // Propiedades para exportación
  private apiUrl = environment.baseUrl;
  public isExporting: boolean = false;
  public exportMessage: string = '';

  constructor(
    private gtp: Gtp,
    private puntosService: PuntosService,
    private MapToolsService: MapToolsService,
    private cdRef: ChangeDetectorRef,
    private http: HttpClient,
    private authService: AuthenticationService
  ) {

  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    //this.listaMoviles = this.moviles.sort(this.gtp.orderMoviles);
    //this.listaMovilesFiltered = this.listaMoviles;
    this.getGrupoPuntos();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  closeTab(event?: Event):void {

    this.getGrupoPuntos()
    this.eventClose.emit(event);
  }

  filterGrupos(query) {
    console.log(query)
    //let res = this.grupos.filter(s => (s.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    //this.gruposFiltered = (query == '') ? this.grupos : res;
  }

  async parseGrupoPuntos(res){
    let data = [];
    let puntos = [];
    Object.values(res).forEach(el => {
      let grupo = new PuntoGrupo(el);
      data.push(grupo);
      puntos = puntos.concat(grupo.puntos);
    });
    return {
      grupos: data,
      puntos: puntos
    }
  }

  async getGrupoPuntos() {
    //this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator;
    this.puntosService.getGrupos(true).subscribe( async res => {
      console.log(res)
      let punto = await this.parseGrupoPuntos(res);
      //console.log(punto.puntos[0]);

      //this.listaPuntos = punto.puntos;
      //this.listaPuntosFiltered = this.listaPuntos;

      this.grupos = punto.grupos;
      this.gruposFiltered = this.grupos;

      //this.dataSource = new MatTableDataSource(this.listaPuntos);
      //this.tableCount = this.dataSource.data.length;
      //this.dataSource.sort = this.sort;
      //this.dataSource.paginator = this.paginator;

    });
  }

  getPuntosdeGrupos(grupo){
    //console.log(grupo)
    var puntos = [];
    grupo.map( gr => {
      gr.puntos.map(punto => {
        puntos.push(punto);
      });
    });
    //console.log(grupo);
    console.log(puntos);

    //this.dataSource = new MatTableDataSource(puntos);
    //this.tableCount = this.dataSource.data.length;
    //this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator;

    //console.log(puntos)
    //this.puntosService.setPuntosClienteObs(puntos);
    this.listaPuntos = puntos;
    this.listaPuntosFiltered = this.listaPuntos;
  }

  upIrAPunto(punto):void {
    console.log(punto)
    this.MapToolsService.setCenterMapa({ latitud: punto.latitud, longitud: punto.longitud, zoom: 15 });
  }

  filterPuntos(query) {
     let res = this.listaPuntos.filter(s => (
      //console.log(s)
      s.nombre.toLocaleLowerCase().includes(query.toLocaleLowerCase())
    ));
    this.listaPuntosFiltered = (query == '') ? this.listaPuntos.sort(this.gtp.orderPuntos) : res.sort(this.gtp.orderPuntos);
  }

  showAllHidePuntos(state) {
    let newlist = [];

    this.listaPuntosFiltered.forEach(el => {
        //console.log(el)
        el.checked = state;
        if (el.checked == true) {
          newlist.push(el);
        }
    });
    this.mostrarTodos = (state) ? false : true;
    //this.listaPuntosFiltered = newlist.sort(this.gtp.orderPuntos);
    //this.listaPuntos = this.listaPuntosFiltered;
    this.puntosService.setPuntosClienteObs( newlist);

  }

  showHidePunto(state, gid) {
    let newlist = [];
    this.listaPuntosFiltered.forEach( (el,i) => {
      if (el.gid == gid) {
        el.checked = state;
      }
      if (el.checked == true) {
        newlist.push(el);
      }
    });
    //this.listaPuntosFiltered = newlist.sort(this.gtp.orderPuntos);
    //this.MapToolsService.setPuntoMapObs(newlist);
    this.puntosService.setPuntosClienteObs(newlist);
  }

  runTest(index) {
    console.log(index);
    console.log(this.listaPuntosFiltered);
  }

  setPagination(event?) {
    // this.filter.pageIndex = parseInt(event.pageIndex);
    return event;
  }

  getPageSizeOptions(): number[] {
    return [10, 20, this.tableCount];
  }

  exportPoints(): void {
    this.isExporting = true;
    this.exportMessage = '';

    this.http.get(`${this.apiUrl}puntos/export`, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${this.authService.accessToken}`
      }
    }).subscribe({
      next: (response) => {
        this.isExporting = false;
        
        // Crear blob y descargar archivo
        const blob = new Blob([response], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Generar nombre de archivo con fecha
        const today = new Date().toISOString().split('T')[0];
        link.download = `puntos_exportados_${today}.xlsx`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.exportMessage = 'Puntos exportados exitosamente';
        setTimeout(() => this.exportMessage = '', 3000);
      },
      error: (error) => {
        this.isExporting = false;
        console.error('Error exporting points:', error);
        
        if (error.status === 404) {
          this.exportMessage = 'No hay puntos registrados para exportar';
        } else {
          this.exportMessage = 'Error al exportar los puntos';
        }
        setTimeout(() => this.exportMessage = '', 5000);
      }
    });
  }

}
